import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class PatientlocalService {
  patientData = [];
  constructor() {}
  savePatient(patArray) {
    this.patientData = patArray;
  }
  getPatients() {
    return this.patientData;
  }
}
